// extracted by mini-css-extract-plugin
var _1 = "PostBodySkeleton-modulecontainer__W8OJ9";
var _2 = "PostBodySkeleton-modulecontent__f74zg";
var _3 = "PostBodySkeleton-moduleimage__hcayN";
var _4 = "PostBodySkeleton-moduletextContent__n4wSt";
var _5 = "PostBodySkeleton-moduletitle__YX8Rh";
export { _1 as "container", _2 as "content", _3 as "image", _4 as "textContent", _5 as "title" }
